import { Theme } from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";
import { Token } from "../../theme";

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      formContainer: {},
      root: {
        backgroundColor: Token.surfaceCard,
        padding: "16px",
        margin: "0px",
        maxHeight: "inherit",
        width: "100%",
        flexDirection: "column",
        "& .MuiTextField-root": {
          marginTop: 0,
          marginBottom: theme.spacing(1.5),
          marginLeft: 0,
          marginRight: 0,
          width: "100%",
        },
        "& .MuiFormControl-root": {
          marginBottom: theme.spacing(1.5),
          marginLeft: 0,
          marginRight: 0,
          width: "100%",
        },
        "& .MuiDivider-root": {
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(3),
          marginLeft: 0,
          width: "100%",
        },
        "& .MuiFormControlLabel-root": {
          padding: 0,
          margin: 0,
          marginTop: theme.spacing(1),
          display: "flex",
          gap: "3px",
        },
        "& .MuiButtonBase-root": {
          margin: 0,
        },
        "& .MuiInputBase-root": {
          backgroundColor: "transparent",
          border: `1px solid ${Token.borderDefault}`,
          borderRadius: "5px",

          "&::before": {
            border: "none",
          },
        },
        "& .MuiFilledInput-root": {
          backgroundColor: "transparent",
        },
      },
    }),
  { index: 1 },
);
